import { Box, CloseButton, Drawer } from "@mantine/core";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FC, useEffect, useState } from "react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ContextModalProps, modals } from "@mantine/modals";
import { useDisclosure } from "@mantine/hooks";
import MapRouter from "./MapRouter";
import { Tab as MapRouterTab } from "./MapRouter";

interface Props {
  onClose?: () => void;
  isFullscreen?: boolean;
}

const RoutesDrawer: FC<ContextModalProps<Props>> = ({
  context, id, innerProps
}) => {
  const [opened, {open, close }] = useDisclosure(false);
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [mapRouterTab, setMapRouterTab] = useState<MapRouterTab>(MapRouterTab.CURRENT_ROUTE);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedView, setSelectedView] = useState<string | null>(null);
  const [hasRouteChanged, setHasRouteChanged] = useState(false);

  useEffect(() => {
    open();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Drawer
      opened={opened}
      withOverlay={innerProps?.isFullscreen ? false : true}
      zIndex={1000}
      size={innerProps?.isFullscreen ? 'calc(100vh - 70px)' : "calc(100vh - 20px)"}
      transitionProps={innerProps?.isFullscreen ? {
        duration: 0,
      } : {}}
      p={0}
      radius={!innerProps?.isFullscreen ? "30px 30px 0 0": "auto"}
      onClose={() => {
        if (innerProps?.onClose) {
          innerProps?.onClose();
        }
        close();
        context.closeModal(id);
      }}
      position={innerProps?.isFullscreen ? "top" : "bottom"}
      variant="baseball-card"
      styles={{
        header: {
          display: "none",
        },
        body: {
          height: "100%",
          boxSizing: "border-box",
          padding: 0,
        }
      }}
    >
      <Box
        p={0}
        w="100%"
        h="100%"
        pos="relative"
        style={{
          boxSizing: "border-box"
        }}>
        {!innerProps?.isFullscreen && (
          <CloseButton
            size="xl"
            pos="absolute"
            top={25}
            right={10}
            style={{
              zIndex: 5002,
            }}
            onClick={() => {
              if (innerProps?.onClose) {
                innerProps?.onClose();
              }
              close();
              context.closeModal(id);
            }} />
        )}
        <Box pt={innerProps?.isFullscreen ? 25 : 55}
          style={{
            position: "relative",
            boxSizing: "border-box",
            height: "100%",
            padding: "0 10px"
          }}>
          <MapRouter 
            setShowUnsavedChangesModal={setShowUnsavedChangesModal} showUnsavedChangesModal={showUnsavedChangesModal}
            tab={mapRouterTab} 
            setSelectedView={setSelectedView} 
            hasRouteChanged={hasRouteChanged} 
            setHasRouteChanged={setHasRouteChanged}/> 
        </Box>
      </Box>
    </Drawer>
  );
};

export const openRoutesDrawer = (
  opts: {
    isFullscreen?: boolean,
  },
  onClose?: () => void,
): string => {
  return modals.openContextModal({
    modal: "routesDrawer",
    innerProps: {
      onClose: onClose,
      isFullscreen: opts?.isFullscreen,
    },
    withOverlay: false,
    withCloseButton: false,
    variant: "baseball-card",
  });
};

export default RoutesDrawer;